import axios from '@config/axios-config';
import { IApiResponse } from '@datatype/common/api-type';
import {
  IInhouseSignInRequest,
  IInhouseSignupRequest,
  IUserData,
  IModifyMeRequest,
  IGetOAuthPageRequest,
  IOAuthPageData,
  IIssueCodeRequest,
  IIssueCodeData,
  ISigninData,
  IAuthenticateCodeRequest,
  ISignupData,
  IOAuthSignupRequest,
  IMyUsernamesRequest,
  IRepasswordRequest,
} from '@datatype/auth/api-type';

// TODO: 여기서 에러 분기처리하는거, useApiMutation, useApiQuery로 빼기

export const testGetApi = async () => {
  const response = await axios.get('https://jsonplaceholder.typicode.com/posts/1');
  const { data } = response;
  await new Promise((resolve, reject) => setTimeout(() => resolve('...'), 3000));
  // throw new Error("error"); -> onError로 감 / onError로 가면 ErrorBoundary 동작
  return data;
};

export const testPostApi = async (input) => {
  const body = { title: 'foo', body: 'bar', userId: 1 };
  const response = await axios.post('https://jsonplaceholder.typicode.com/posts', body);
  const { data } = response;
  // throw new Error("error"); -> onError로 감
  return data;
};

// 인증코드 발급 api
export const issueCodeApi = async (input: IIssueCodeRequest): Promise<IApiResponse<IIssueCodeData>> => {
  const { service, username, email, type } = input;
  const body = { service, username, email, type };
  const response = await axios
    .post<IApiResponse<IIssueCodeData>>('/api/v1/auth/issue-code', body)
    .then((res) => res.data);
  return response;
};

// 인증코드 검증 api
export const authenticateCodeApi = async (input: IAuthenticateCodeRequest): Promise<IApiResponse<void>> => {
  const { email, code } = input;
  const body = { email, code };
  const response = await axios.post<IApiResponse<void>>('/api/v1/auth/authenticate-code', body).then((res) => res.data);
  return response;
};

// inhouse 회원가입 api
export const inhouseSignupApi = async (input: IInhouseSignupRequest): Promise<IApiResponse<ISignupData>> => {
  const { service, username, email, password, marketingConsent, studentKey } = input;
  const body = { service, email, username, password, marketingConsent, studentKey };
  const response = await axios.post<IApiResponse<ISignupData>>(`/api/v1/auth/signup`, body).then((res) => res.data);
  return response;
};

export const inhouseSigninApi = async (input: IInhouseSignInRequest): Promise<IApiResponse<ISigninData>> => {
  const { service, username, password } = input;
  const body = { service, username, password };
  const response = await axios.post<IApiResponse<ISigninData>>('/api/v1/auth/signin', body).then((res) => res.data);
  return response;
};

// oauth page url을 받는 api
export const getOAuthPage = async (request: IGetOAuthPageRequest): Promise<IApiResponse<IOAuthPageData>> => {
  const { service, type, kind } = request;
  const response = await axios
    .get<IApiResponse<any>>(`/api/v1/auth/oauth-page?service=${service}&type=${type}&kind=${kind}`)
    .then((res) => res.data);
  return response;
};

// oauth signup api
export const oauthSignUp = async (request: IOAuthSignupRequest): Promise<IApiResponse<ISignupData>> => {
  // const response = await axios
  //   .get<IApiResponse<void>>(`/api/v1/auth/oauth-signup?email=${email}&marketingConsent=${marketingConsent}`)
  //   .then((res) => res.data);
  // const oauthSignUpEndpoint = `${API_SERVER}/api/v1/auth/oauth-signup?type=${type}&username=${username}&email=${email}&marketingConsent=${marketingConsent}`;
  // window.location.href = oauthSignUpEndpoint;
  // axios로 하면, frontend(axios) -> backend -> redirect -> axios redirect 처리로 cors 에러가 발생, 따라서 브라우저 접속(get)으로 변경
  const { service, authType, username, email, marketingConsent, studentKey } = request;
  const body = { service, authType, email, username, marketingConsent, studentKey };
  const response = await axios
    .post<IApiResponse<ISignupData>>(`/api/v1/auth/oauth-signup`, body)
    .then((res) => res.data);
  return response;
};

// 나의 정보 조회 api
export const findMe = async (): Promise<IApiResponse<IUserData>> => {
  const response = await axios.get<IApiResponse<IUserData>>(`/api/v1/auth/me`).then((res) => res.data);
  return response;
};

// 나의 username 목록 조회 api
export const findMyUsers = async (request: IMyUsernamesRequest): Promise<IApiResponse<IUserData[]>> => {
  const { service, email } = request;
  const response = await axios
    .get<IApiResponse<IUserData[]>>(`/api/v1/auth/me/user?service=${service}&email=${email}`)
    .then((res) => res.data);
  return response;
};

// 나의 정보 수정 api
export const modifyMe = async (request: IModifyMeRequest) => {
  const { currentPassword, newPassword } = request;
  const body = { currentPassword, newPassword };
  const response = await axios.patch<IApiResponse<IUserData>>(`/api/v1/auth/me`, body);
  return response.data;
};

// 비밀번호 재설정 api
export const repassword = async (request: IRepasswordRequest) => {
  const { service, username, password } = request;
  const body = { service, username, password };
  const response = await axios.post<IApiResponse<void>>(`/api/v1/auth/me/repassword`, body);
  return response.data;
};

// 회원탈퇴 api
export const removeMe = async (): Promise<IApiResponse<Pick<IUserData, 'key'>>> => {
  const response = await axios.delete<IApiResponse<Pick<IUserData, 'key'>>>(`/api/v1/auth/me`).then((res) => res.data);
  return response;
};

// 로그아웃 api
export const signOutApi = async (): Promise<IApiResponse<void>> => {
  const body = {};
  const response = await axios.post<IApiResponse<void>>(`/api/v1/auth/signout`, body).then((res) => res.data);
  return response;
};
